module.exports = __webpack_public_path__ + "img/gmotion-bg.d7cb8b0c.jpg";